import { render, staticRenderFns } from "./prescriptionTable.vue?vue&type=template&id=8ebb35d6&scoped=true"
import script from "./prescriptionTable.vue?vue&type=script&lang=js"
export * from "./prescriptionTable.vue?vue&type=script&lang=js"
import style0 from "./prescriptionTable.vue?vue&type=style&index=0&id=8ebb35d6&prod&lang=scss&scoped=true"
import style1 from "./prescriptionTable.vue?vue&type=style&index=1&id=8ebb35d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebb35d6",
  null
  
)

export default component.exports